import useSWR, { KeyedMutator } from 'swr';

import { generateApiPath, getCollection } from '#app/Handler/api';
import UserPreparerEntryPoints from '#app/entrypoints/userPreparer';
import { UserPreparer } from '#app/typings/userPreparer';

type HookReturn = {
  userPreparers: UserPreparer[];
  loading: boolean;
  mutate: KeyedMutator<UserPreparer[]>;
};

const useUserPreparers = (): HookReturn => {
  const {
    data: userPreparers,
    isLoading,
    mutate,
  } = useSWR<UserPreparer[]>(generateApiPath(UserPreparerEntryPoints.getCollectionActive), getCollection, {
    refreshInterval: 20000,
  });

  return {
    userPreparers: userPreparers ?? [],
    loading: isLoading,
    mutate,
  };
};

export default useUserPreparers;
